import { useState } from "react";
import NTNavbar from "@/components/feature/NTNavbar";
import NTFooter from "@/components/feature/NTFooter";
import { Link } from "react-router-dom";

const contactInfo = [
  {
    icon: "ri-map-pin-2-line",
    title: "Endereço",
    lines: ["Rua Gentile Schimitt, 320, Bairro Santa Terezinha", "Gaspar, SC – 89114-395"],
  },
  {
    icon: "ri-phone-line",
    title: "Telefone",
    lines: ["+55 (47) 9774-0084", " "],
  },
  {
    icon: "ri-mail-line",
    title: "E-mail",
    lines: [
      "comercial@newtechsolution.com.br",
      "financeiro@newtechsolution.com.br",
      "contato@newtechsolution.com.br",
    ],
  },
  {
    icon: "ri-time-line",
    title: "Horário de Atendimento",
    lines: ["Segunda a Quinta: 07:30h às 17:30h", "Sexta: 07:30h às 16:30h"],
  },
];

const segments = [
  "Metalúrgico",
  "Têxtil",
  "Alimentício",
  "Automobilístico",
  "Higiene Pessoal",
  "Químico",
  "Farmacêutico",
  "Outro",
];

const interests = [
  "Automação Industrial",
  "Fabricação de Máquinas Especiais",
  "Acessórios para Equipamentos",
  "Retrofit e Modernização",
  "Engenharia de Projetos",
  "Assistência Técnica",
];

type FormStatus = "idle" | "sending" | "success" | "error";

export default function ContactPage() {
  const [formStatus, setFormStatus] = useState<FormStatus>("idle");
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus("sending");
    const form = e.currentTarget;
    const data = Object.fromEntries(new FormData(form).entries());

    try {
      const res = await fetch("/api/contato.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const json = await res.json();
      if (res.ok && json.ok) {
        setFormStatus("success");
        form.reset();
        setCharCount(0);
      } else {
        setFormStatus("error");
      }
    } catch {
      setFormStatus("error");
    }
  };

  return (
    <div className="min-h-screen bg-white font-inter">
      <NTNavbar />
      <main className="pt-[88px]">

        {/* Hero */}
        <section className="relative h-[300px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20industrial%20office%20reception%20professional%20team%20meeting%20bright%20clean%20corporate%20environment%20manufacturing%20company%20Brazil&width=1400&height=360&seq=ntcontacthero&orientation=landscape"
            alt="Contato New Tech Solution"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a]/85 via-[#1a1a1a]/55 to-transparent"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-6 w-full">
              <div className="flex items-center gap-2 mb-3">
                <Link to="/" className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">Home</Link>
                <span className="text-white/40 text-sm">/</span>
                <span className="text-[#3FA7D6] text-sm font-semibold">Contato</span>
              </div>
              <h1 className="font-rajdhani font-bold text-white text-4xl md:text-5xl">Fale com Nossa Equipe</h1>
              <p className="text-white/70 text-base mt-2">Estamos prontos para desenvolver a solução ideal para o seu negócio.</p>
            </div>
          </div>
        </section>

        {/* Contact info cards */}
        <section className="bg-[#f5f5f5] py-10">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {contactInfo.map((item) => (
                <div key={item.title} className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#1B1F5E] transition-all group">
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#1B1F5E]/10 text-[#1B1F5E] mb-4 group-hover:bg-[#1B1F5E] group-hover:text-white transition-all">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-rajdhani font-bold text-[#1a1a1a] text-base mb-2">{item.title}</h3>
                  {item.lines.map((line, i) => (
                    <p key={i} className="text-[#666] text-sm leading-relaxed">{line}</p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Form + Map */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">

              {/* Form — 3 cols */}
              <div className="lg:col-span-3">
                <div className="mb-8">
                  <p className="text-[#1B1F5E] font-bold text-sm uppercase tracking-widest mb-2">Solicite um Orçamento</p>
                  <h2 className="font-rajdhani font-bold text-[#1a1a1a] text-3xl md:text-4xl leading-tight">
                    Vamos conversar sobre<br />
                    <span className="text-[#1B1F5E]">seu projeto</span>
                  </h2>
                  <p className="text-[#666] text-sm mt-3 leading-relaxed">
                    Preencha o formulário abaixo e nossa equipe de especialistas entrará em contato em até 24 horas úteis.
                  </p>
                </div>

                {formStatus === "success" ? (
                  <div className="bg-[#1B1F5E]/10 border border-[#1B1F5E]/30 rounded-lg p-10 text-center">
                    <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#1B1F5E] text-white mx-auto mb-4">
                      <i className="ri-check-line text-3xl"></i>
                    </div>
                    <h3 className="font-rajdhani font-bold text-[#1a1a1a] text-2xl mb-2">Mensagem Enviada!</h3>
                    <p className="text-[#555] text-sm leading-relaxed mb-6">
                      Obrigado pelo contato! Nossa equipe retornará em até 24 horas úteis.
                    </p>
                    <button
                      onClick={() => setFormStatus("idle")}
                      className="inline-flex items-center gap-2 bg-[#1B1F5E] hover:bg-[#2F4F8F] text-white font-bold px-6 py-3 rounded-md transition-colors cursor-pointer text-sm"
                    >
                      Enviar Nova Mensagem
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                    {/* Name + Company */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-[#1a1a1a] uppercase tracking-wide">Nome Completo *</label>
                        <input
                          name="nome"
                          required
                          type="text"
                          placeholder="Seu nome completo"
                          className="border border-gray-200 rounded-md px-4 py-3 text-sm outline-none focus:border-[#1B1F5E] transition-colors placeholder-gray-400"
                        />
                      </div>
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-[#1a1a1a] uppercase tracking-wide">Empresa *</label>
                        <input
                          name="empresa"
                          required
                          type="text"
                          placeholder="Nome da empresa"
                          className="border border-gray-200 rounded-md px-4 py-3 text-sm outline-none focus:border-[#1B1F5E] transition-colors placeholder-gray-400"
                        />
                      </div>
                    </div>

                    {/* Email + Phone */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-[#1a1a1a] uppercase tracking-wide">E-mail *</label>
                        <input
                          name="email"
                          required
                          type="email"
                          placeholder="seu@email.com.br"
                          className="border border-gray-200 rounded-md px-4 py-3 text-sm outline-none focus:border-[#1B1F5E] transition-colors placeholder-gray-400"
                        />
                      </div>
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-[#1a1a1a] uppercase tracking-wide">Telefone / WhatsApp</label>
                        <input
                          name="telefone"
                          type="tel"
                          placeholder="(11) 99999-9999"
                          className="border border-gray-200 rounded-md px-4 py-3 text-sm outline-none focus:border-[#1B1F5E] transition-colors placeholder-gray-400"
                        />
                      </div>
                    </div>

                    {/* Cargo + Segment */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-[#1a1a1a] uppercase tracking-wide">Cargo</label>
                        <input
                          name="cargo"
                          type="text"
                          placeholder="Ex: Diretor Industrial"
                          className="border border-gray-200 rounded-md px-4 py-3 text-sm outline-none focus:border-[#1B1F5E] transition-colors placeholder-gray-400"
                        />
                      </div>
                      <div className="flex flex-col gap-1.5">
                        <label className="text-xs font-semibold text-[#1a1a1a] uppercase tracking-wide">Segmento Industrial</label>
                        <select
                          name="segmento"
                          className="border border-gray-200 rounded-md px-4 py-3 text-sm outline-none focus:border-[#1B1F5E] transition-colors text-gray-600 cursor-pointer"
                        >
                          <option value="">Selecione seu segmento</option>
                          {segments.map((s) => <option key={s}>{s}</option>)}
                        </select>
                      </div>
                    </div>

                    {/* Interest */}
                    <div className="flex flex-col gap-1.5">
                      <label className="text-xs font-semibold text-[#1a1a1a] uppercase tracking-wide">Área de Interesse</label>
                      <select
                        name="interesse"
                        className="border border-gray-200 rounded-md px-4 py-3 text-sm outline-none focus:border-[#1B1F5E] transition-colors text-gray-600 cursor-pointer"
                      >
                        <option value="">Selecione uma área</option>
                        {interests.map((i) => <option key={i}>{i}</option>)}
                      </select>
                    </div>

                    {/* Message */}
                    <div className="flex flex-col gap-1.5">
                      <div className="flex items-center justify-between">
                        <label className="text-xs font-semibold text-[#1a1a1a] uppercase tracking-wide">Mensagem *</label>
                        <span className={`text-xs ${charCount > 450 ? "text-red-500" : "text-gray-400"}`}>{charCount}/500</span>
                      </div>
                      <textarea
                        name="mensagem"
                        required
                        rows={5}
                        maxLength={500}
                        placeholder="Descreva sua necessidade, o tipo de equipamento, capacidade desejada, prazo e qualquer informação relevante para o projeto..."
                        onChange={(e) => setCharCount(e.target.value.length)}
                        className="border border-gray-200 rounded-md px-4 py-3 text-sm outline-none focus:border-[#1B1F5E] transition-colors resize-none placeholder-gray-400"
                      />
                    </div>

                    {/* How did you find us */}
                    <div className="flex flex-col gap-1.5">
                      <label className="text-xs font-semibold text-[#1a1a1a] uppercase tracking-wide">Como nos encontrou?</label>
                      <select
                        name="origem"
                        className="border border-gray-200 rounded-md px-4 py-3 text-sm outline-none focus:border-[#1B1F5E] transition-colors text-gray-600 cursor-pointer"
                      >
                        <option value="">Selecione uma opção</option>
                        <option>Google / Pesquisa</option>
                        <option>Indicação</option>
                        <option>LinkedIn</option>
                        <option>Instagram</option>
                        <option>Feira / Evento</option>
                        <option>Anúncio</option>
                        <option>Outro</option>
                      </select>
                    </div>

                    {/* Error message */}
                    {formStatus === "error" && (
                      <div className="bg-red-50 border border-red-200 rounded-md px-4 py-3 text-red-600 text-sm">
                        Ocorreu um erro ao enviar. Por favor, tente novamente ou entre em contato pelo WhatsApp.
                      </div>
                    )}

                    {/* Submit */}
                    <button
                      type="submit"
                      disabled={formStatus === "sending"}
                      className="flex items-center justify-center gap-2 bg-[#1B1F5E] hover:bg-[#2F4F8F] disabled:opacity-60 text-white font-bold py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm uppercase tracking-wider"
                    >
                      {formStatus === "sending" ? (
                        <>
                          <i className="ri-loader-4-line animate-spin"></i>
                          Enviando...
                        </>
                      ) : (
                        <>
                          Enviar Solicitação
                          <div className="w-4 h-4 flex items-center justify-center"><i className="ri-send-plane-line"></i></div>
                        </>
                      )}
                    </button>

                    <p className="text-[#999] text-xs text-center">
                      Ao enviar, você concorda com nossa{" "}
                      <a href="#" className="text-[#1B1F5E] hover:underline cursor-pointer">Política de Privacidade</a>.
                      Retornaremos em até 24 horas úteis.
                    </p>
                  </form>
                )}
              </div>

              {/* Map + extra info — 2 cols */}
              <div className="lg:col-span-2 flex flex-col gap-6">
                {/* Map */}
                <div className="rounded-lg overflow-hidden border border-gray-200 h-72">
                  <iframe
                    title="New Tech Solution - Localização"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.0975898697!2d-46.6333094!3d-23.5505199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce59c8da0aa315%3A0xd59f9431f2c9776a!2sAv.%20Paulista%2C%20S%C3%A3o%20Paulo%20-%20SP!5e0!3m2!1spt-BR!2sbr!4v1700000000000!5m2!1spt-BR!2sbr"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                {/* WhatsApp CTA */}
                <a
                  href="https://wa.me/5547997740084"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-center gap-4 bg-[#25d366] hover:bg-[#1ebe5d] text-white rounded-lg p-5 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 shrink-0">
                    <i className="ri-whatsapp-line text-2xl"></i>
                  </div>
                  <div>
                    <p className="font-rajdhani font-bold text-base">Fale pelo WhatsApp</p>
                    <p className="text-white/80 text-sm">Resposta rápida em horário comercial</p>
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center ml-auto group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </a>

                {/* Social */}
                <div className="bg-[#f5f5f5] rounded-lg p-6 border border-gray-100">
                  <h4 className="font-rajdhani font-bold text-[#1a1a1a] text-base mb-4">Siga-nos nas Redes Sociais</h4>
                  <div className="flex flex-col gap-3">
                    {[
                      { icon: "ri-instagram-line", label: "@newtechsolution", color: "#E1306C" },
                      { icon: "ri-linkedin-line", label: "New Tech Solution", color: "#0077B5" },
                      { icon: "ri-youtube-line", label: "New Tech Solution", color: "#FF0000" },
                    ].map((social) => (
                      <a
                        key={social.label}
                        href="#"
                        className="flex items-center gap-3 text-[#555] hover:text-[#1B1F5E] transition-colors cursor-pointer group"
                      >
                        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white border border-gray-200 group-hover:border-[#1B1F5E] transition-colors">
                          <i className={`${social.icon} text-sm`} style={{ color: social.color }}></i>
                        </div>
                        <span className="text-sm font-medium">{social.label}</span>
                      </a>
                    ))}
                  </div>
                </div>

                {/* FAQ quick */}
                <div className="bg-white rounded-lg p-6 border border-gray-200">
                  <h4 className="font-rajdhani font-bold text-[#1a1a1a] text-base mb-4">Perguntas Frequentes</h4>
                  <div className="flex flex-col gap-3">
                    {[
                      { q: "Qual o prazo médio de entrega?", a: "Varia conforme o projeto. Em média, de 60 a 180 dias." },
                      { q: "Vocês atendem fora de Santa Catarina?", a: "Sim! Atendemos todo o território nacional." },
                      { q: "Fazem projetos sob medida?", a: "Sim, essa é nossa especialidade principal." },
                    ].map((faq) => (
                      <div key={faq.q} className="border-b border-gray-100 pb-3 last:border-0 last:pb-0">
                        <p className="font-semibold text-[#1a1a1a] text-xs mb-1">{faq.q}</p>
                        <p className="text-[#666] text-xs leading-relaxed">{faq.a}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA bottom */}
        <section className="bg-[#f5c518] py-5">
          <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-rajdhani font-black text-[#1a1a1a] text-xl md:text-2xl uppercase">PRECISA DE ATENDIMENTO URGENTE?</p>
              <p className="text-[#1a1a1a]/70 text-sm mt-0.5">Ligue agora e fale diretamente com um especialista.</p>
            </div>
            <a
              href="tel:+554797740084"
              className="whitespace-nowrap bg-[#1a1a1a] hover:bg-[#333] text-white font-bold px-8 py-3 rounded-md transition-colors cursor-pointer text-sm flex items-center gap-2"
            >
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill"></i></div>
              +55 (47) 9774-0084
            </a>
          </div>
        </section>

      </main>
      <NTFooter />
    </div>
  );
}
